import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter, TemplateRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { UpdateFilterObj } from '../menu-categories/models/menu-categories.model';

import { CategoryNameInfo, ToolBarCategory } from './models/category-tool-bar.model';

import { Category } from '@core/domain/models/category.models';
import { getLanguageisRTL } from '@core/infrastructure/state/core.selectors';
import { CategoryFilterState, filterGroupArrayNames } from '@pages/category'; // TODO ECOMDUTI-25790
import { GridDefault } from '@pages/category/modules/category-grid/public_api'; // TODO ECOMDUTI-25790

@Component({
    selector: 'category-tool-bar',
    templateUrl: './category-tool-bar.component.html',
})

/**
 * Barra de enlaces y filtros de parrillas
 */
export class CategoryToolBarComponent implements OnChanges {
    @Input() public category: ToolBarCategory;

    @Input() public selectGridView: TemplateRef<any>;

    @Input() public isFilterApplied = false;

    @Input() public showIfNoScrollDelay = true;

    @Input() public lastPageYOffset = 100;

    @Input() public productsId: number[];

    @Input() public customCategory: GridDefault;

    @Input() public filters: CategoryFilterState;

    @Input() public currentCategory: Category;

    @Input() public filterTypeUsed: filterGroupArrayNames;

    @Output() public readonly updateFilterEmitter: EventEmitter<UpdateFilterObj> = new EventEmitter();

    @Output() public readonly categoryIdEmitter: EventEmitter<string> = new EventEmitter();

    @Output() public readonly showFilterEmitter: EventEmitter<boolean> = new EventEmitter();

    @Output() public readonly categoryNameInfoEmitter: EventEmitter<CategoryNameInfo> = new EventEmitter();

    public isRtl$: Observable<boolean> = this.store.select(getLanguageisRTL);

    private categoryId: string;

    public showFilter: boolean;

    constructor(private readonly store: Store) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.category?.currentValue) {
            this.categoryId = changes.category?.currentValue?.currentCategory?.id ?? changes.category?.currentValue?.id;
            this.categoryIdEmitter.emit(this.categoryId);

            // Solo comprobamos los filtros en caso de que la categoría sea de tipo parrilla, para los lookbooks no los queremos mostrar
            const categoryAttachments = changes.category?.currentValue?.currentCategory?.attachments;
            this.showFilter = categoryAttachments && !categoryAttachments.some((item) => item.name === 'hide_filters');
            this.showFilterEmitter.emit(this.showFilter);
        }
    }

    public updateFilter(updateFilterObj: UpdateFilterObj): void {
        this.updateFilterEmitter.emit(updateFilterObj);
    }

    public updateCategoryNameInfo(categoryNameInfo: CategoryNameInfo): void {
        let categoryName = '';
        if (categoryNameInfo.currentCategoryFromABTest?.level === 3) {
            categoryName = categoryNameInfo.currentCategoryFromABTest?.parentName;
        } else {
            categoryName = categoryNameInfo.categoryName;
        }
        const newCategoryNameInfo = {
            ...categoryNameInfo,
            categoryName: categoryName,
        };
        this.categoryNameInfoEmitter.emit(newCategoryNameInfo);
    }
}
